const _excluded = ["style", "className", "open", "disabled", "title", "description", "illustrationType", "hideIllustration", "linkText"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';
import { stylePropType } from '@adsk/alloy-react-theme';
const DefaultContent = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style = {
        padding: 0
      },
      className,
      open,
      disabled,
      title,
      description,
      illustrationType,
      hideIllustration,
      linkText
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(EmptyState, _extends({}, rest, {
    hideIllustration: hideIllustration,
    ref: ref,
    title: title || T.translate('DRAG_FILES_HERE'),
    description: description,
    className: className,
    style: style,
    illustrationType: illustrationType || EmptyState.ILLUSTRATION_TYPES.FOLDER_PDF_CLOSED_FIST_GREY
  }), /*#__PURE__*/React.createElement(LinkButton, {
    disabled: disabled,
    onClick: e => {
      open && open();
      // that is because the entire dropzone is clickable
      e.stopPropagation();
    }
  }, linkText || T.translate('CHOOSE_FILES')));
});
DefaultContent.displayName = 'DefaultContent';
DefaultContent.propTypes = _objectSpread(_objectSpread({}, EmptyState.propTypes), {}, {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Function that opens file browser */
  open: PropTypes.func,
  /** Whether dropzone is disabled */
  disabled: PropTypes.bool
});
export default Object.assign(DefaultContent, {
  ILLUSTRATION_TYPES: EmptyState.ILLUSTRATION_TYPES
});
//# sourceMappingURL=DefaultContent.js.map